module.exports = __webpack_public_path__ + "img/symbol-sqrt-left.76c2d52b.png";